import { EXTERNAL_LOYALTY_PARTNERS } from "../../data/constants/shared";
import { REDEEM_OTP } from "../constants";
import { defineProfile } from "./defaultProfile";

/**
 * DotPe — the **programme-driven** partner, and the only one today that publishes a per-channel
 * loyalty programme (`program/fetch`).
 *
 * That single fact produces most of its divergence: the programme decides the points→money rate,
 * what points are called, which items they may not be spent on, whether the merchant may redeem
 * on the POS at all, and whether enrolment needs an OTP. Because the programme also applies the
 * percentage / ceiling / minimum-order caps server-side, the numbers it returns are final and are
 * NOT capped again against the bill.
 *
 * ⚠️ Its programme is cached per CHANNEL, not per provider, so every rule that reads one pairs it
 * with `publishesProgram`. See `LoyaltyProviderProfile.publishesProgram`.
 */
export const dotpeProfile = defineProfile(EXTERNAL_LOYALTY_PARTNERS.DOTPE, {
  publishesProgram: true,
  requiresLiveProgramToRedeem: true,
  capsOwnRedemption: true,
  usesProgramRedemptionValue: true,
  redeemOtpLength: REDEEM_OTP.PROGRAM_DRIVEN_LENGTH,
  // Asks the balance endpoint for the redeemable view rather than the raw balance.
  loyaltyDetailsFetchMode: "redeemable",
  supportsItemExclusions: true,
  supportsEnrollmentConsent: true,
  requiresLiveProgramForConsent: true,
  honoursSkipEnrollmentOtp: true,
});
